(() => {
  const templateSelector = '[data-bundle-frontend-options-template]';
  const productSelector = '.bndlr-product[data-product-id]';
  let instanceId = 0;
  let injectionScheduled = false;

  const makeIdsUnique = (container) => {
    instanceId += 1;
    const suffix = `bundle-${instanceId}`;
    const idMap = new Map();

    container.querySelectorAll('[id]').forEach((element) => {
      const previousId = element.id;
      const nextId = `${previousId}-${suffix}`;

      idMap.set(previousId, nextId);
      element.id = nextId;
    });

    container.querySelectorAll('label[for]').forEach((label) => {
      const nextId = idMap.get(label.htmlFor);
      if (nextId) label.htmlFor = nextId;
    });
  };

  const injectOptions = () => {
    document.querySelectorAll(templateSelector).forEach((template) => {
      const productId = template.dataset.productId;
      const configId = template.dataset.configId;

      document.querySelectorAll(`${productSelector}[data-product-id="${productId}"]`).forEach((product) => {
        if (product.querySelector(`[data-bundle-frontend-options][data-config-id="${configId}"]`)) return;

        const fragment = template.content.cloneNode(true);
        const options = fragment.querySelector('[data-bundle-frontend-options]');

        if (!options) return;

        makeIdsUnique(options);

        const insertionPoint = product.querySelector('.bndlr-bottom-pusher, .bndlr-select-variant');
        product.insertBefore(fragment, insertionPoint || null);
      });
    });
  };

  const scheduleInjection = () => {
    if (injectionScheduled) return;

    injectionScheduled = true;
    window.requestAnimationFrame(() => {
      injectionScheduled = false;
      injectOptions();
    });
  };

  document.addEventListener('bundler:bundle_widget_created', scheduleInjection);
  document.addEventListener('shopify:section:load', scheduleInjection);
  document.addEventListener('change', (event) => {
    const options = event.target.closest?.('[data-bundle-frontend-options]');
    if (!options) return;

    options.classList.remove('is-invalid');
    options.closest('.bndlr-container')?.querySelector('.bndlr-cart-redirect-warning')?.remove();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInjection, { once: true });
  } else {
    scheduleInjection();
  }

  new MutationObserver((mutations) => {
    const hasRelevantAddition = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(productSelector) || node.querySelector?.(productSelector)),
      ),
    );

    if (hasRelevantAddition) scheduleInjection();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
